// 更新协同备注
import { computed } from 'vue'
import { useStore } from 'vuex'
import { get as Get } from 'lodash'
import { message } from 'ant-design-vue'
import {
  updatePatRemark,
  getPatientRemarkNotes,
  getDoctRemarkNotes,
  updateDoctRemark
} from '@/api/workPlace/remark'
export default function useRemark(initParam = {}) {
  const store = useStore()
  const groupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  const userInfo = computed(() => store.state.user.userInfo)
  // 更新患者的协同备注
  function updatePatientRemark(content, patientProfileId) {
    return new Promise((resolve, reject) => {
      const params = {
        remarkId: userInfo.value.ucUserId,
        remarkPersonType: 2, // 备注人类别：1-BD，2-协同备注/健管,3-医生辅助账号
        beRemarkId: Get(groupInfo, 'value.patientInfo.businessId', ''),
        beRemarkUcUserId: Get(groupInfo, 'value.patientInfo.ucUserId'),
        beRemarkContent: content,
        beRemarkType: 3, // 被备注内容类别：1-名称，2-其他，3-协同备注名称
        beRemarkPersonType: 1, // 被备注人类别：1-患者，2-医生
        businessId: Get(groupInfo, 'value.doctorInfo.ucUserId'),
        patientProfileId: patientProfileId || Get(groupInfo, 'value.patientInfo.ucUserId') // 就诊人id
      }
      updatePatRemark(params)
        .then(() => {
          message.success('操作成功')
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  }
  // 更新医生协同备注
  function updateDoctorRemark(content) {
    const { doctorId, ucDoctorId } = initParam || {}
    return new Promise((resolve, reject) => {
      const params = {
        remarkId: userInfo.value.ucUserId,
        remarkPersonType: 2,
        beRemarkId: doctorId || Get(groupInfo, 'value.doctorInfo.businessId', ''),
        beRemarkUcUserId: ucDoctorId || Get(groupInfo, 'value.doctorInfo.ucUserId'),
        beRemarkContent: content,
        beRemarkType: 3,
        beRemarkPersonType: 2,
        businessId: ucDoctorId || Get(groupInfo, 'value.doctorInfo.ucUserId') // bd/医助给患者备注时，为医生用户中心id
      }
      updateDoctRemark(params)
        .then(() => {
          message.success('操作成功')
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  }
  // 获取患者协同备注
  const getPatientRemark = params => {
    const { ucDoctorId, ucPatientId } = params
    return new Promise((resolve, reject) => {
      const params = {
        ucPatientId,
        ucDoctorId,
        patientProfileId: ucPatientId
      }
      getPatientRemarkNotes(params)
        .then(res => {
          resolve(res || {})
        })
        .catch(() => {
          reject({})
        })
    })
  }
  // 获取医生协同备注
  const getDoctRemark = params => {
    const { ucDoctorId } = params
    return new Promise((resolve, reject) => {
      const params = {
        ucDoctorId
      }
      getDoctRemarkNotes(params)
        .then(res => {
          resolve(res || {})
        })
        .catch(() => {
          reject({})
        })
    })
  }
  // 获取协同备注
  function getRemarkData(params) {
    const query = [getPatientRemark(params), getDoctRemark(params)]
    return new Promise((resolve, reject) => {
      Promise.allSettled(query).then(res => {
        resolve(res)
      })
    })
  }
  return {
    updatePatientRemark,
    getRemarkData,
    updateDoctorRemark,
    getDoctRemark
  }
}
